// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"Loader_ldsSpinner__1vjMW"};